<div class="ui-g form-container">
  <form [formGroup]='setPasswordForm'>
    <div>

      <div class="ui-g">
        <div class="form-field ui-g-12 UI-MD-12 ui-lg-12">
          <div class="form-errors alert alert-danger" [hidden]='!passwordError[0]["general"]'>
            <div *ngFor="let ErrorMessage of passwordError['general']">
              {{ErrorMessage.message}}
            </div>
          </div>
        </div>
      </div>
 
      <div class="ui-g">
        <div class="form-field ui-g-12">
          <div class="form-label ui-g-12">
            <label for="newPassword">New Password</label>
          </div>
          <div class="form-control ui-g-12">
            <input type="password" pInputText formControlName="newPassword" />
          </div>
          <div class="form-errors" *ngIf="setPasswordForm.controls.newPassword.errors  && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
            <div [hidden]="!setPasswordForm.controls.newPassword.errors.required">
              New Password is required
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g">
        <div class="form-field ui-g-12">
          <div class="form-label ui-g-12">
            <label for="newConfirmPassword">New Confirm Password</label>
          </div>
          <div class="form-control ui-g-12">
            <input type="password" pInputText formControlName="newConfirmPassword" />
          </div>
          <div class="form-errors" *ngIf="setPasswordForm.controls.newConfirmPassword.errors  && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)">
            <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.required">
              Please Confirm Password
            </div>
          </div>
        </div>

      </div>
      <div class="ui-g">
        <div class="form-buttons ui-g-12">
          <button pButton type="button" label="Save" icon="fa fa-check" [disabled]="!setPasswordForm.valid" (click)="doChangePassword()"></button>
          <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel" (click)="onCancel()"></button>
        </div>
      </div>
    </div>
  </form>
</div>
<p-growl [value]="errorMessage"></p-growl>